export const unmaskMoney = value => (value ? parseInt(value.replace(/\./g, '')) : undefined);
